import React, { useContext } from "react";
import Tilt from "react-tilt";
import { LanguageContext, text } from "../../container/language";
import { buildURLForArticle } from "../../utils/buildURL";
import Link from "../../utils/Link";

const FastLink = ({ icon, slug, title, parentCategory }) => {
  const { userLanguage } = useContext(LanguageContext);

  return (
    <Tilt
      className="fast-links__item"
      options={{
        max: 25,
        scale: 1,
        perspective: 2000,
        easing: "cubic-bezier(.03,.98,.52,.99)",
      }}
    >
      <div className="fast-links__item-inner">
        <div className="fast-links__image">
          <i className={icon}></i>
        </div>
        <div className="fast-links__title">
          <Link to={`${buildURLForArticle(parentCategory)}/${slug}`}>
            <font>
              <font>{text(title, userLanguage)}</font>
            </font>
          </Link>
        </div>
      </div>
    </Tilt>
  );
};

export default FastLink;
